import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  vanBanDenDuThao: {},
  isCaNhan: false,
  danhSachDonViNgoaiHeThong: [
    {
      stt: 1,
      tenDonViNhan: "asdasd",
      trangThai: "asdasd",
      phaiGuiBanGiay: "adad",
      thaoTac: "asdasdas",
    },
    {
      stt: 1,
      tenDonViNhan: "asdasd",
      trangThai: "asdasd",
      phaiGuiBanGiay: "adad",
      thaoTac: "asdasdas",
    },
  ],
  danhSachVanBanTraLoi: [
    {
      khongTuDongHoanThanh: true,
      soDen: "asd",
      soKyHieu: "asd",
      donViBanHanh: "asd",
      trichYeu: "asdasd",
      tepDinhKem: "adas",
    },
    {
      khongTuDongHoanThanh: false,
      soDen: "asd",
      soKyHieu: "asd",
      donViBanHanh: "asd",
      trichYeu: "asdasd",
      tepDinhKem: "adas",
    },
  ],
  danhSachDonViChiDao: [],
  danhSachDonViKyDuyet: [
    {
      hoTen: "ádasdas",
      donVi: "asd",
      vaiTro: "asd",
      banHanh: "asd",
    },
  ],
  danhSachVanBanDi: {},
  loaiVanBanDi: [
    {
      id: true,
      Id: true,
      name: "Văn bản đi ban hành",
    },
    {
      id: false,
      Id: false,
      name: "Văn bản nội bộ",
    },
  ],
  soLuongVanBanDi: {},
  chiTietVanBanDi: null,
  vanBanDenVanBanDi: [],
  multiVanBanDen: [],
  danhSachNguoiDuocTraLai: {},
  listXinSo: [],
  donViDaBanHanh: {},
  lichSuCapNhat: [],
  lichSuTraLai: [],
  lichSuThuHoi: [],
  lichSuHuyDuyet: [],
  luongXuLy: [],
  lichSuKyDuyet: [],
  lichSuTheoDoiLienThong:[],
  lichSuTheoDoiVB: [],
  donViNgangCap: [],
  nguoiXuLyTiepTheo: {},
  downloadFileDinhKem: [],
  dsSoBiGiu: [],
  getSinhSoNoiBo: [],
  chuyenVung: [],
  danhSachTrangThaiDashBoardVanBanDi: [
    {
      field: "SoLuongChoTrinhKy",
      path: "cho-trinh-ky",
      Code: "CHO_TRINH_KY",
      Name: "Chờ trình ký",
      Value: 0,
    },
    {
      field: "SoLuongChoXuLy",
      path: "cho-xu-ly-vb-di",
      Code: "CHO_XU_LY",
      Name: "Chờ xử lý",
      Value: 0,
    },
    {
      field: "SoLuongDaXuLy",
      path: "da-xu-ly-vb-di",
      Code: "DA_XU_LY",
      Name: "Đã xử lý",
      Value: 0,
    },
    {
      field: "SoLuongDaTraLai",
      path: "da-tra-lai",
      Code: "DA_TRA_LAI",
      Name: "Đã trả lại",
      Value: 0,
    },
    {
      field: "SoLuongChoCapSo",
      path: "cho-cap-so",
      Code: "CHO_CAP_SO",
      Name: "Chờ cấp số",
      Value: 0,
    },
    {
      field: "SoLuongChoBanHanh",
      path: "cho-ban-hanh",
      Code: "CHO_BAN_HANH",
      Name: "Chờ ban hành",
      Value: 0,
    },
    {
      field: "SoLuongDaBanHanh",
      path: "da-ban-hanh",
      Code: "DA_BAN_HANH",
      Name: "Đã ban hành",
      Value: 0,
    },
    {
      field: "SoLuongNoiBo",
      path: "noi-bo",
      Code: "NOI_BO",
      Name: "Nội bộ",
      Value: 0,
    },
    {
      field: "SoLuongQuaHan",
      Code: "QUA_HAN",
      Name: "Quá hạn",
      Value: 0,
    },
    {
      field: "SoLuongDenHan",
      Code: "DEN_HAN",
      Name: "Đến hạn",
      Value: 0,
    },
    {
      field: "SoLuongChoTrinhKy",
      Code: "TRONG_HAN",
      Name: "Trong hạn",
      Value: 0,
    },
    {
      field: "SoLuongKhongCoHan",
      Code: "KHONG_CO_HAN",
      Name: "Không có hạn",
      Value: 0,
    },
  ],
  dvDaBanHanh: {},
  danhSachMultiVanBanDi: {},
  form: null,
  notReloadList: false,
  dongChiTietVanBan: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
